import "core-js/modules/es6.regexp.replace";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  data: function data() {
    return {
      info: {},
      visible: false
    };
  },
  methods: {
    open: function open(data) {
      var ticket = JSON.parse(JSON.stringify(data));
      ticket.purchase_notice = ticket.purchase_notice.replace(/\n/g, '<br/>');
      ticket.description = ticket.description.replace(/\n/g, '<br/>');
      ticket.withdrawal_notice = ticket.withdrawal_notice.replace(/\n/g, '<br/>');
      this.info = ticket;
      this.visible = true;
    }
  }
};